import { render } from "./StatisticReceiptsCmp.vue?vue&type=template&id=dca5e6ae"
import script from "./StatisticReceiptsCmp.vue?vue&type=script&lang=js"
export * from "./StatisticReceiptsCmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__